import React from "react";
import adaptiveTest from "./data";
import { upcomingSlots, todayInIST, formatSessionDate, formatFee } from "./schedule";

// Full Adaptive Test schedule for the candidate's Adaptive Test tab (#cat) in Profile.js.
// Props exist only so tests can pass fixed content and a fixed "today".
const AdaptiveTestSchedule = ({ content = adaptiveTest, today = todayInIST() }) => {
  const rows = upcomingSlots(content.sessions, today);

  return (
    <div>
      <p className="mt-3 mb-0">
        <b>Fee:</b> {formatFee(content.fee)}
      </p>
      <p className="mb-0">{content.conductedBy}</p>
      {rows.length > 0 ? (
        <div style={{ overflowX: "auto" }}>
          <table className="table table-bordered mt-3">
            <thead className="table-primary">
              <tr>
                <th>Date</th>
                <th>Centre</th>
                <th>Address</th>
                <th>Slot</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={`${row.date}-${row.name}-${row.slot}`}>
                  <td className="candTable">{formatSessionDate(row.date)}</td>
                  <td className="candTable">{row.name}</td>
                  <td className="candTable">{row.address || "—"}</td>
                  <td className="candTable">{row.slot}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-center text-danger mt-3">New dates coming soon</p>
      )}
    </div>
  );
};

export default AdaptiveTestSchedule;
